///<amd-module name="typeahead/core/logging/ScanabilityLogger" />

import {CollectorTransport} from "typeahead/core/logging/CollectorTransport";
import {ScanabilityMetric} from "typeahead/core/logging/ScanabilityMetric";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {SuggestionShownMessage} from "typeahead/core/message/SuggestionShownMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class ScanabilityLogger {

    private lob: string;
    private domElementId: string;
    private suggestionShownTimestamp: number;
    private suggestionSelectedTimestamp: number;
    private selectionMethod: string;
    private activeESSTests: string = "";

    constructor() {
        // Suggestions displayed
        TypeaheadMessage.subscribe(
            SuggestionShownMessage.getTopic(), (topic: string, message: SuggestionShownMessage) => {
                this.domElementId = message.getDomElementId();
                this.lob = message.getLob();
                this.activeESSTests = message.getActiveESSTests();
                this.suggestionShownTimestamp = Date.now();
            },
        );

        // Suggestion selected
        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
            (topic: string, message: SuggestionSelectedMessage) => {
                if (this.domElementId) {
                    this.selectionMethod = message.getSelectionMethod();
                    this.suggestionSelectedTimestamp = Date.now();
                    this.emitScanabilityMetric();

                    // reset logger state
                    this.domElementId = undefined;
                    this.lob = undefined;
                    this.selectionMethod = undefined;
                    this.suggestionShownTimestamp = 0;
                    this.suggestionSelectedTimestamp = 0;
                }
            },
        );
    }

    private emitScanabilityMetric(): void {
        new CollectorTransport().log(new ScanabilityMetric(
            this.lob,
            this.domElementId,
            this.suggestionShownTimestamp,
            this.suggestionSelectedTimestamp,
            this.selectionMethod,
            this.activeESSTests));
    }
}
